import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Flex, Text, Image, Divider, Link, Input, IconButton, Button } from '@chakra-ui/react';
import { CheckCircleIcon, CheckIcon, TriangleDownIcon } from '@chakra-ui/icons';
import styled from 'styled-components';
import lockIcon from '../Images/Share_lock_icon.png';
import sharingInvalid from '../Images/icon/share_no_exist.svg';
import logoImg from '../Images/icon/logo.svg';
import Footer from '../Components/General/Footer';
import { single_paction } from '../Utils/api';
//get password
import { getLinkPassword } from '../Utils/api';
import visibleIcon from '../Images/icon/visible.svg';
import invisibleIcon from '../Images/icon/Invisible.svg';
// getTransaction api
import { getTransactionInfo } from '../Utils/api';
// 11/21 getBasedata api
import { getBasedata, logOpenRecord } from '../Utils/api';
import '../Styles/theme/PasswordModel.css';
// add blockchain_window
import '../Styles/theme/blockchain_window.css';
export default function Share() {
  const { certName, token, date } = useParams();
  const [existed, setExisted] = useState(false);
  const [certInfo, setCertInfo] = useState({});
  const [chemicalUrl, setChemicalUrl] = useState('');
  const [showReminder, setShowReminder] = useState(false);
  const [url, setUrl] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [ifNeedPassword, setIfNeedPassword] = useState(false);
  const [showHiddenInfo, setHiddenInfo] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [tx_place_no, setTxPlaceNo] = useState('');
  const [tx_company_no, setTxCompanyNo] = useState('');
  const [tx_paction_no, setTxPactionNo] = useState('');
  const [tx_TransactionHash, setTxHash] = useState('');
  const [tx_block_hash, setTxBlockHash] = useState('');
  const [tx_block_number, setTxBlockNumber] = useState('');
  const [tx_raw_data, setTxRawData] = useState('');
  // 11/21 add get_basedata
  const [place_name, setPlaceName] = useState('');
  const [place_address, setPlaceAddress] = useState('');
  const [company_name, setCompanyName] = useState('');
  const [company_address, setCompanyAddress] = useState('');

  // add slice raw data function
  const splitStringWithBrackets = (str, maxLength) => {
    const chunks = [];
    let start = 0;
    while (start < str.length) {
      const end = start + maxLength;
      chunks.push(`[${str.slice(start, end)}]`);
      start = end;
    }
    return chunks.map((chunk, index) => (
      <React.Fragment key={index}>
        {chunk}
        <br />
      </React.Fragment>
    ));
  };
  // 11/21 add getBasedata
  const handleGetBaseData = (place_no, company_no) => {
    getBasedata(place_no, company_no)
      .then((res) => {
        setPlaceName(res.place_name);
        setPlaceAddress(res.place_address);
        setCompanyName(res.company_name);
        setCompanyAddress(res.company_address);
      });
  };
  const handleLinkClick = (transaction_hash) => {
    getTransactionInfo(transaction_hash)
      .then((response_data) => {
        setTxPlaceNo(response_data.place_no);
        setTxCompanyNo(response_data.company_no);
        setTxPactionNo(response_data.paction_no);
        setTxBlockHash(response_data.block_hash);
        setTxBlockNumber(response_data.block_number);
        setTxRawData(response_data.raw_data);
        setTxHash(transaction_hash);
      });
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleVerify = () => {
    // fix: send password to backend to verify
    getLinkPassword(certInfo.paction_no, password)
      .then((res) => {
        if (res.correct) {
          handleGetBaseData(certInfo.place_no, certInfo.company_no);
          alert('密碼正確!');
          setHiddenInfo(true);
        } else {
          setHiddenInfo(false);
          alert('密碼錯誤!');
        }
      })
      .catch((error) => {
        alert('取得密碼時發生錯誤', error);
      });
  };

  useEffect(() => {
    sessionStorage.clear();
    sessionStorage.setItem('token', JSON.stringify(token));
    let d = new Date();
    single_paction(certName)
      .then((res) => {
        setCertInfo(res.data[0]);
        setExisted(true);
        // 連結一打開即記錄查閱並上鏈，不論是否設定密碼（密碼只擋詳細資訊）
        logOpenRecord(token, "Guest").catch(console.error);

        setUrl(
          process.env.REACT_APP_END_POINT +
          '/paction/share/pdf/' +
          token +
          '?' +
          d.getTime(),
        );
        // 11/22
        // alert(res.data[0].place_no);
        // alert(res.data[0].company_no);

        getLinkPassword(res.data[0].paction_no)
          .then((linkPasswordRes) => {
            // fix: check 'has_password' instead of 'password' for the new secure backend
            if (linkPasswordRes.has_password || linkPasswordRes.password) {
              setIfNeedPassword(true);
              setHiddenInfo(false);
            } else {
              // for those not setting password
              setIfNeedPassword(false);
              setHiddenInfo(true);
              handleGetBaseData(res.data[0].place_no, res.data[0].company_no);
            }
          })
          .catch((error) => {
            alert('Error getting link password:', error);
          });
      })
      .catch(() => {
        setExisted(false);
      });
    setChemicalUrl('/sharechemical/' + certName + '/' + date);
  }, []);

  return (
    <Stack h="100%" w="100%" bgColor={'#FFFFFF'}>
      {showModel && (
        <div className="overlay_blockchain">
          <div className="modal_blockchain" onClick={(e) => e.stopPropagation()}>
            <div className="header_blockchain">
              <span className="title_blockchain">鏈上資訊瀏覽器</span>
            </div>
            <div className="body_blockchain">
              <div className="left-column">
                <div className="row_blockchain">
                  <span className="label_blockchain">區塊號碼:</span>
                  <br />
                  <span className="value_blockchain">{tx_block_number}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">證書編號:</span>
                  <br />
                  <span className="value_blockchain">{tx_paction_no}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">運作場所管編:</span>
                  <br />
                  <span className="value_blockchain">{tx_place_no}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">運作人管編:</span>
                  <br />
                  <span className="value_blockchain">{tx_company_no}</span>
                </div>
              </div>
              <div className="right-column">
                <div className="row_blockchain">
                  <span className="label_blockchain">區塊 hash 值:</span>
                  <br />
                  <span className="value_blockHash_Tx_blockchain">{tx_block_hash}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">鏈上 Tx:</span>
                  <br />
                  <span className="value_blockHash_Tx_blockchain">{tx_TransactionHash}</span>
                </div>
                <div className="row_blockchain">
                  <span className="label_blockchain">16進位值:</span>
                  <div className="value_hexRawData_blockchain raw-data_blockchain">
                    {splitStringWithBrackets(tx_raw_data, 50)}
                  </div>
                </div>
              </div>
            </div>
            <div className="footer_blockchain">
              <button className="exit-button_blockchain" onClick={(e) => { e.stopPropagation(); setShowModel(false); }}>離開瀏覽器</button>
            </div>
          </div>
        </div>
      )}
      <Flex w="100%" h="64px" justify="space-between" align="center">
        <Flex w="-webkit-fit-content" m={5} px={5} alignItems="center">
          <Image src={logoImg} />
          <Text fontSize="xl" color="#0B4654" ml={15}>
            {/* 化學署區塊鏈數位證書 */}
            化學雲區塊鏈應用
          </Text>
        </Flex>
        {existed && (
          <Text mx="22.5px" fontSize="20px" lineHeight="150%">
            此證書自 {date.replaceAll('-', '/')} 經持有人啟用分享
          </Text>
        )}
      </Flex>
      {existed ? (
        <Flex w="100%" minH="calc(100vh - 64px - 58px)" my="24px">
          <Flex
            position="relative"
            minH="700px"
            w="45%"
            ml="67.5"
            bgColor="#E0E0E0"
            justify="center"
            alignItems="center"
          >
            <PDFViewer
              visibility="visible"
              data={`${url}#toolbar=0`}
              type="application/pdf"
              title="share_cert"
            />
            <Image
              position="absolute"
              bottom="20px"
              right="22.5px"
              h="82px"
              w="82px"
              src={lockIcon}
            />
          </Flex>
          <Flex w="50%" direction="column">
            <Flex
              w="100%"
              mt="32px"
              position="relative"
              align="center"
              justify="space-between"
              pr="32px"
            >
              <Flex
                position="relative"
                w="231px"
                h="72px"
                mt="32px"
                borderRadius="0px 50px 50px 0px"
                bgColor="green.500"
                justify="center"
                align="center"
                onMouseEnter={() => setShowReminder(true)}
                onMouseLeave={() => setShowReminder(false)}
              >
                <CheckCircleIcon w="40px" h="40px" mx="4px" color="white" />
                <Text
                  fontSize="30px"
                  lineHeight="40px"
                  fontWeight="600"
                  color="white"
                >
                  驗證成功
                </Text>
                {showReminder && (
                  <Flex
                    position="absolute"
                    left="255px"
                    alignItems="center"
                    bg="transparent"
                  >
                    <TriangleDownIcon
                      mr="-3px"
                      color="green.50"
                      transform="rotate(90deg)"
                    />
                    <Flex
                      w="211px"
                      h="79px"
                      px="12px"
                      py="8px"
                      borderRadius="3px"
                      bgColor="green.50"
                      fontSize="20px"
                      lineHeight="30px"
                      color="green.500"
                      direction="column"
                      justify="center"
                      align="start"
                      shadow="0px 4px 8px rgba(37, 42, 49, 0.16), 0px 8px 24px rgba(37, 42, 49, 0.24)"
                    >
                      <Text>
                        <CheckIcon w="16px" h="16px" mx="4px" />
                        此證書為合法證書
                      </Text>
                      <Text>
                        <CheckIcon w="16px" h="16px" mx="4px" />
                        此證書未被篡改
                      </Text>
                    </Flex>
                  </Flex>
                )}
              </Flex>
              {(!ifNeedPassword || (ifNeedPassword && showHiddenInfo)) && (
                <Button
                  as="a"
                  href={url}
                  download={`${certInfo.paction_no || '許可證'}_${company_name ? company_name.substring(0, 10) : ''}_${new Date().toISOString().split('T')[0]}.pdf`}
                  bg="#35658D"
                  color="white"
                  fontSize="16px"
                  fontWeight="500"
                  px="16px"
                  py="8px"
                  borderRadius="6px"
                  mt="48px"
                  _hover={{ bg: "#2c4f7a", color: "white" }}
                >
                  下載許可證
                </Button>
              )}
            </Flex>
            <Stack
              w="100%"
              mt="10vh"
              pl="5vw"
              pr="5vw"
              fontSize="20px"
              wordBreak="break-word"
            >
              <Flex alignItems="center" pb="20px">
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  縣市別
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Text ml="59px" lineHeight="36px">
                  {certInfo.location}
                </Text>
              </Flex>
              <Flex alignItems="center" pb="20px">
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  運作人管編
                  <br />
                  /名稱
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Text ml="59px" lineHeight="36px">
                  {certInfo.company_no}
                </Text>
              </Flex>
              <Flex alignItems="center" pb="20px">
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  運作場所管編
                  <br />
                  /名稱
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Text ml="59px" lineHeight="36px">
                  {certInfo.place_no}
                </Text>
              </Flex>
              <Flex alignItems="center" pb="20px">
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  證件編號
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Text ml="59px" lineHeight="36px">
                  {certInfo.paction_no}
                </Text>
              </Flex>
              <Flex alignItems="center" pb="20px" l>
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  鏈上Tx
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Link
                  onClick={() => { handleLinkClick('0x' + certInfo.tx_hash); setShowModel(true); }}
                  ml="59px"
                  lineHeight="32px"
                  fontSize="18px"
                >
                  {'0x' + certInfo.tx_hash}
                </Link>
              </Flex>
              <Flex alignItems="center" mt="20px">
                <Text lineHeight="32px" fontWeight="600" minW="160px">
                  化學物質
                </Text>
                <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                <Link
                  ml="59px"
                  lineHeight="32px"
                  fontSize="20px"
                  href={chemicalUrl}
                >
                  查看更多
                </Link>
              </Flex>
              {/*增加新欄位*/}
              {ifNeedPassword && (
                <Flex alignItems="center" mt="20px">
                  <Text lineHeight="32px" fontWeight="600" minW="160px">
                    輸入密碼
                  </Text>
                  <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                  <Flex alignItems="center" ml="59px">
                    <Input
                      fontSize="20px"
                      type={showPassword ? 'text' : 'password'}
                      width="202px"
                      height="44px"
                      padding="10px 12px"
                      borderRadius="3px"
                      border="1px solid #A8B8C2"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <IconButton
                      aria-label={showPassword ? '隱藏密碼' : '顯示密碼'}
                      icon={showPassword ? <img src={invisibleIcon} alt="Hide password" /> : <img src={visibleIcon} alt="Show password" />}
                      onClick={() => setShowPassword(!showPassword)}
                      variant="ghost"
                      size="sm"
                    />
                    <Button
                      onClick={handleVerify}
                      variant="solid"
                      bg="#008E96"
                      color="white" // 设置文本颜色为白色
                      size="sm"
                      _hover={{ // 添加悬停效果
                        bg: '#007685', // 悬停时背景颜色变浅
                        boxShadow: 'md', // 添加小阴影
                      }}
                    >
                      驗證
                    </Button>
                  </Flex>
                </Flex>
              )}
              {/* {showHiddenInfo && place_name!="" && ( */}
              {showHiddenInfo && place_name != "" && (
                <Flex alignItems="center" pb="20px">
                  <Text lineHeight="32px" fontWeight="600" minW="160px">
                    運作場所名稱
                  </Text>
                  <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                  <Text ml="59px" lineHeight="36px">
                    {place_name}
                  </Text>
                </Flex>
              )}
              {showHiddenInfo && place_address != "" && (
                <Flex alignItems="center" pb="20px">
                  <Text lineHeight="32px" fontWeight="600" minW="160px">
                    運作場所地址
                  </Text>
                  <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                  <Text ml="59px" lineHeight="36px">
                    {place_address}
                  </Text>
                </Flex>
              )}
              {showHiddenInfo && company_name != "" && (
                <Flex alignItems="center" pb="20px">
                  <Text lineHeight="32px" fontWeight="600" minW="160px">
                    運作人名稱
                  </Text>
                  <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                  <Text ml="59px" lineHeight="36px">
                    {company_name}
                  </Text>
                </Flex>
              )}
              {showHiddenInfo && company_address != "" && (
                <Flex alignItems="center" pb="20px">
                  <Text lineHeight="32px" fontWeight="600" minW="160px">
                    運作人地址
                  </Text>
                  <Divider orientation="vertical" h="25px" bg="black" w="3px" />
                  <Text ml="59px" lineHeight="36px">
                    {company_address}
                  </Text>
                </Flex>
              )}
            </Stack>
          </Flex>
        </Flex>
      ) : (
        <Flex
          w="100%"
          my="24px"
          direction="column"
          align="center"
          justify="center"
        >
          <Image h="calc(100vh - 72px - 111px)" src={sharingInvalid} />
        </Flex>
      )}
      <Footer />
    </Stack>
  );
}
const PDFViewer = styled.object`
  flex-grow: 1;
  height: 100%;
  margin: auto;
`;

